import { SummaryResponse } from '../contentqnaPluginTypes';

export class SummaryTaskAlreadyCompletedError extends Error {
	public constructor(public task: SummaryResponse) {
		super('Summary already exists');
		this.name = 'SummaryTaskAlreadyCompletedError';
	}
}
